<div class="vrste-problema-page">

    <div class="vrste-problema-page__container">
        <vrste-problema-tablica [type]="tipVrsteProblema"></vrste-problema-tablica>
    </div>

</div>